import cn from 'classnames';
import React, { useCallback, useEffect, useId, useRef } from 'react';
import getI18N from '../../lib/i18n';
import { hideCode } from '../../store/form';
import {
    formSelector,
    generatedCodeSelector,
    generatedUrlSelector,
    widgetTypeSelector,
} from '../../store/form/selectors';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { showMessage } from '../../store/popup/thunks';
import { MetrikaGoals, reachGoal } from '../../utils/metrika';
import Button from '../Button/Button';
import styles from './CodeResult.module.scss';

export const CodeResult = () => {
    const dispatch = useAppDispatch();
    const generatedCode = useAppSelector(generatedCodeSelector);
    const generatedUrl = useAppSelector(generatedUrlSelector);
    const widgetType = useAppSelector(widgetTypeSelector);
    const { fields } = useAppSelector(formSelector);
    const { isPriceShown, routeType } = fields;
    const i18n = getI18N();
    const resultFieldId = useId();
    const resultFieldRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        resultFieldRef.current?.select();
    });

    const handleNewWidgetButtonClick = useCallback(() => {
        dispatch(hideCode());
    }, [dispatch]);
    const isLinkWithoutPrice = widgetType === 'link' && (!isPriceShown || routeType === 'none');

    const handleCopyButtonClick = useCallback(() => {
        if (!resultFieldRef.current) return;
        if (window?.navigator?.clipboard) {
            reachGoal(MetrikaGoals.copyWigetCode);
            window.navigator.clipboard.writeText(resultFieldRef.current.value);
        } else {
            resultFieldRef.current.select();
            document.execCommand('copy');
        }
        dispatch(showMessage(i18n('Текст успешно скопирован'), 2000));
    }, [i18n, dispatch]);
    return (
        <>
            <div className={styles.container}>
                <label className={styles['result-label']} htmlFor={resultFieldId}>
                    {i18n('Скопируйте код и установите на сайте')}
                </label>

                <textarea
                    className={cn(styles['result-field'], 'scroller-block')}
                    ref={resultFieldRef}
                    id={resultFieldId}
                    cols={30}
                    rows={10}
                    defaultValue={isLinkWithoutPrice ? generatedUrl : generatedCode}
                    key={new Date().getTime()}
                />

                <button
                    className={styles['copy-button']}
                    type="button"
                    onClick={handleCopyButtonClick}
                >
                    {i18n('Копировать')}
                </button>
            </div>
            <div className={styles['button-container']}>
                <Button
                    className={styles['new-widget-button']}
                    icon="reload"
                    text={i18n('Новый виджет')}
                    onClick={handleNewWidgetButtonClick}
                />
            </div>
        </>
    );
};
